import "./Pagination.scss";
import ButtonPagination from "./components/Button";
import PaginationArrowBtn from "./components/PaginationArrowBtn";

const Pagination = ({ totalItems, active, setActive }) => {
    const pageCount = Math.ceil(totalItems / 6);

    // Определяем размер окна — на мобилке 3, на десктопе 5
    const isMobile = window.innerWidth < 480;
    const windowSize = isMobile ? 1 : 2; // соседей с каждой стороны

    if (pageCount <= 1) return null;

    if (pageCount <= (isMobile ? 5 : 7)) {
        return (
            <div className="pagination">
                <PaginationArrowBtn active={active} setActive={setActive} rotate reduce />
                {Array.from({ length: pageCount }, (_, i) => (
                    <ButtonPagination
                        key={i + 1}
                        active={active}
                        setActive={setActive}
                        pageNumber={i + 1}
                    />
                ))}
                <PaginationArrowBtn pageCount={pageCount} active={active} setActive={setActive} />
            </div>
        );
    }

    let windowStart = active - windowSize;
    let windowEnd = active + windowSize;

    if (windowStart <= 2) {
        windowStart = 2;
        windowEnd = 2 + windowSize * 2;
    }
    if (windowEnd >= pageCount - 1) {
        windowEnd = pageCount - 1;
        windowStart = pageCount - 1 - windowSize * 2;
    }

    const pages = Array.from(
        { length: windowEnd - windowStart + 1 },
        (_, i) => windowStart + i
    );

    const showLeftEllipsis = windowStart > 2;
    const showRightEllipsis = windowEnd < pageCount - 1;

    return (
        <div className="pagination">
            <PaginationArrowBtn active={active} setActive={setActive} rotate reduce />

            <ButtonPagination active={active} setActive={setActive} pageNumber={1} />

            <span className={`pagination__ellipsis ${!showLeftEllipsis ? "pagination__ellipsis--hidden" : ""}`}>
                …
            </span>

            {pages.map(page => (
                <ButtonPagination
                    key={page}
                    active={active}
                    setActive={setActive}
                    pageNumber={page}
                />
            ))}

            <span className={`pagination__ellipsis ${!showRightEllipsis ? "pagination__ellipsis--hidden" : ""}`}>
                …
            </span>

            <ButtonPagination active={active} setActive={setActive} pageNumber={pageCount} />

            <PaginationArrowBtn pageCount={pageCount} active={active} setActive={setActive} />
        </div>
    );
};

export default Pagination;